// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-registration-eligibility.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-registration-eligibility/aircraft-registration-eligibility.js';
import g1 from '../lessons/air-law/aircraft-registration-eligibility/registered-owner-qualification.js';
import g2 from '../lessons/air-law/aircraft-registration-eligibility/registration-types.js';

mount([g0, g1, g2]);
